import {
  newsFunc
} from "./pages/_news";

$(window).on('load', function () {
  newsFunc();
});

document.addEventListener('DOMContentLoaded', function() {
  //-----------------------------------------------------
  // News filter
  //-----------------------------------------------------
  const newsForm = document.getElementById('tagFilterForm');
  const categoryForm = document.getElementById('categoryFilterForm'); // 追加

  const newsCheckboxes = newsForm.querySelectorAll('input[type="checkbox"]');
  const categoryCheckboxes = categoryForm.querySelectorAll('input[type="checkbox"]'); // 追加

  const updateNews = function() {
      const formData = new FormData();

      // Append news form data
      newsCheckboxes.forEach(checkbox => {
          if (checkbox.checked) {
              formData.append(checkbox.name, checkbox.value);
          }
      });

      // Append category form data
      categoryCheckboxes.forEach(checkbox => {
          if (checkbox.checked) {
              formData.append(checkbox.name, checkbox.value);
          }
      });

      formData.append('action', 'filter_news'); // Ensure this matches your PHP action

      fetch(ajax_object.ajax_url, {
          method: 'POST',
          body: formData
      })
      .then(response => response.text())
      .then(data => {
          document.querySelector('.p-news__article').innerHTML = data;
      })
      .catch(error => console.error('Error:', error));
  };

  newsCheckboxes.forEach(checkbox => {
      checkbox.addEventListener('change', updateNews);
  });

  categoryCheckboxes.forEach(checkbox => {
      checkbox.addEventListener('change', updateNews);
  });
});